import CryptoJS from 'crypto-js';

/**
 * @class Aes
 */
export default class Aes {
  static encrypt(text, secretKey, iv="AES-256-CBC") {
    // 使用CryptoJS的AES加密方法
    return CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(secretKey), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
  }
  static decrypt(ciphertext, secretKey, iv="AES-256-CBC") {
    var bytes = CryptoJS.AES.decrypt(ciphertext, CryptoJS.enc.Utf8.parse(secretKey), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return bytes.toString(CryptoJS.enc.Utf8);
  }
}



// WEBPACK FOOTER //
// ./src/common/user/Aes.js